export default __webpack_public_path__ + "static/media/video6.8b6192b3.webp";